<template>
  <div class="competition-admin container">
    <div class="is-pulled-right">
      <nav
        v-if="competition"
        class="breadcrumb"
        aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/">
              Top
            </router-link>
          </li>
          <li
            class="is-active">
            <router-link :to="'/edit/competition/' + competition.pk">
              {{ competition.name }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <h1
      v-if="competition"
      class="title">
      {{ competition.name }}
    </h1>
    <nav
      v-if="days"
      class="panel">
      <p class="panel-heading">
        <translate>Tävlingsdagar</translate>
      </p>
      <div
        v-for="(day, index) of days"
        :key="index"
        class="panel-block">
        <router-link
          :to="'/edit/day/' + day.pk">
          {{ day.name }}
        </router-link>
        <div class="field is-pulled-right has-addons">
          <p class="control">
            <button
              v-if="loggedIn"
              class="button"
              @click="openModal(day.pk)">
              <translate>Ändra Namn</translate>
            </button>
          </p>
          <p class="control">
            <button
              v-if="loggedIn"
              class="button is-danger"
              @click="openDeleteModal(day.pk)">
              <translate>Radera</translate>
            </button>
          </p>
        </div>
        <b-modal
          :active.sync="isComponentModalActive[day.pk]">
          <edit-day :id="day.pk" />
        </b-modal>
        <b-modal
          :active.sync="isComponentDeleteModalActive[day.pk]">
          <delete-day :id="day.pk" />
        </b-modal>
      </div>
      <button
        v-if="loggedIn"
        class="button is-primary"
        @click="openNewModal()">
        <translate>Skapa Ny Tävlingsdag</translate>
      </button>
      <b-modal
        v-if="competition"
        :active.sync="isComponentNewModalActive">
        <new-day :competition="competition.pk" />
      </b-modal>
    </nav>
    <nav
      v-if="teams"
      class="panel">
      <p class="panel-heading">
        <translate>Lag</translate>
      </p>
      <div
        v-for="(team, index) of teams"
        :key="index"
        class="panel-block">
        <p>
          {{ team.number }} - {{ team.name }}
        </p>
        <div class="field is-pulled-right has-addons">
          <p class="control">
            <button
              v-if="loggedIn"
              class="button"
              @click="openTeamModal(team.pk)">
              <translate>Ändra</translate>
            </button>
          </p>
          <p class="control">
            <button
              v-if="loggedIn"
              class="button is-danger"
              @click="openDeleteTeamModal(team.pk)">
              <translate>Radera</translate>
            </button>
          </p>
        </div>
        <b-modal
          :active.sync="isTeamModalActive[team.pk]">
          <edit-team :id="team.pk" />
        </b-modal>
        <b-modal
          :active.sync="isTeamDeleteModalActive[team.pk]">
          <delete-team :id="team.pk" />
        </b-modal>
      </div>
      <button
        v-if="loggedIn"
        class="button is-primary"
        @click="openNewTeamModal()">
        <translate>Skapa Nytt Tävlingslag</translate>
      </button>
      <b-modal
        v-if="competition"
        :active.sync="isTeamNewModalActive">
        <new-team :competition="competition.pk" />
      </b-modal>
      <button
        v-if="loggedIn"
        class="button is-primary"
        @click="openImportTeamModal()">
        <translate>Importera Tävlingslag</translate>
      </button>
      <b-modal
        v-if="competition"
        :active.sync="isTeamImportModalActive">
        <import-team :competition="competition.pk" />
      </b-modal>
    </nav>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  competitionService, dayService, teamService} from '../_services';
import NewDay from '../components/day/New'
import EditDay from '../components/day/Edit'
import DeleteDay from '../components/day/Delete'
import NewTeam from '../components/team/New'
import EditTeam from '../components/team/Edit'
import DeleteTeam from '../components/team/Delete'
import ImportTeam from '../components/team/Import'

export default {
  name: 'CompetitionAdminPage',
  components: {
    NewDay,
    EditDay,
    DeleteDay,
    NewTeam,
    EditTeam,
    DeleteTeam,
    ImportTeam,
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      competition: undefined,
      days: undefined,
      teams: undefined,
      isComponentModalActive: [],
      isComponentDeleteModalActive: [],
      isComponentNewModalActive: false,
      isTeamModalActive: [],
      isTeamDeleteModalActive: [],
      isTeamNewModalActive: false,
      isTeamImportModalActive: false,
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn;
    },
    user () {
      return this.$store.state.authentication.token
    },
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetch'
  },
  created () {
    var self = this
    self.fetch()

  },
  methods: {
    async fetch() {
      var self = this
      try{
        self.competition = await competitionService.get(self.id)
        self.days = await dayService.getAll(self.id)
        self.teams = await teamService.getAll(self.id)
      }catch(err){

        console.error('Caught error')
        console.error(err)
      }
    },
    openModal: function(id){
      var self = this
      Vue.set(self.isComponentModalActive, id, true)
    },
    openDeleteModal: function(id){
      var self = this
      Vue.set(self.isComponentDeleteModalActive, id, true)
    },
    openNewModal: function(){
      var self = this
      self.isComponentNewModalActive = true
    },
    openTeamModal: function(id){
      var self = this
      Vue.set(self.isTeamModalActive, id, true)
    },
    openDeleteTeamModal: function(id){
      var self = this
      Vue.set(self.isTeamDeleteModalActive, id, true)
    },
    openNewTeamModal: function(){
      var self = this
      self.isTeamNewModalActive = true
    },
    openImportTeamModal: function(){
      var self = this
      self.isTeamImportModalActive = true
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-block {
  justify-content: space-between;
}
</style>
